// components/ui/dialog.js
import React, { createContext, useContext, useState } from "react";
import { useConfig } from '../../context/ConfigContext';

const DialogContext = createContext(null);

export function Dialog({ children, open, onOpenChange }) {
  const [isOpen, setIsOpen] = useState(open || false);
  
  const value = {
    open: open !== undefined ? open : isOpen,
    setOpen: onOpenChange || setIsOpen
  };
  
  return (
    <DialogContext.Provider value={value}>
      {children}
    </DialogContext.Provider>
  );
}

export function DialogTrigger({ children, asChild }) {
  const { setOpen } = useContext(DialogContext);
  
  if (asChild) {
    return React.cloneElement(children, {
      onClick: (e) => {
        e.preventDefault();
        setOpen(true);
        if (children.props.onClick) {
          children.props.onClick(e);
        }
      }
    });
  }
  
  return (
    <button onClick={() => setOpen(true)}>
      {children}
    </button>
  );
}

export function DialogContent({ children, className = "" }) {
  const { open, setOpen } = useContext(DialogContext);
  const { config } = useConfig();
  
  if (!open) {
    return null;
  }
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div 
        className={`rounded-lg shadow-lg p-6 max-w-md w-full mx-4 max-h-[85vh] overflow-y-auto ${className}`}
        style={{ backgroundColor: config.colors.background }}
      >
        <button 
          onClick={() => setOpen(false)}
          className="absolute top-4 right-4 hover:text-gray-700"
          style={{ color: config.colors.textSecondary }}
          aria-label="Close"
        >
          ✕
        </button>
        {children}
      </div>
    </div>
  );
}

export function DialogHeader({ className = "", children }) {
  return (
    <div className={`mb-4 ${className}`}>
      {children}
    </div>
  );
}

export function DialogTitle({ className = "", children }) {
  const { config } = useConfig();
  
  return (
    <h2 
      className={`text-lg font-semibold ${className}`}
      style={{ color: config.colors.textPrimary }}
    >
      {children}
    </h2>
  );
}



// // components/ui/dialog.js
// import React, { createContext, useContext, useState } from "react";

// const DialogContext = createContext(null);

// export function Dialog({ children, open, onOpenChange }) {
//   const [isOpen, setIsOpen] = useState(open || false);
  
//   const value = {
//     open: open !== undefined ? open : isOpen,
//     setOpen: onOpenChange || setIsOpen
//   };
  
//   return (
//     <DialogContext.Provider value={value}>
//       {children}
//     </DialogContext.Provider>
//   );
// }

// export function DialogTrigger({ children, asChild }) {
//   const { setOpen } = useContext(DialogContext);
  
//   if (asChild) {
//     return React.cloneElement(children, {
//       onClick: (e) => {
//         e.preventDefault();
//         setOpen(true);
//         if (children.props.onClick) {
//           children.props.onClick(e);
//         }
//       }
//     });
//   }
  
//   return (
//     <button onClick={() => setOpen(true)}>
//       {children}
//     </button>
//   );
// }

// export function DialogContent({ children, className = "" }) {
//   const { open, setOpen } = useContext(DialogContext);
  
//   if (!open) {
//     return null;
//   }
  
//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//       <div 
//         className={`bg-white rounded-lg shadow-lg p-6 max-w-md w-full mx-4 max-h-[85vh] overflow-y-auto ${className}`}
//       >
//         <button 
//           onClick={() => setOpen(false)}
//           className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
//           aria-label="Close"
//         >
//           ✕
//         </button>
//         {children}
//       </div>
//     </div>
//   );
// }

// export function DialogHeader({ className = "", children }) {
//   return (
//     <div className={`mb-4 ${className}`}>
//       {children}
//     </div>
//   );
// }

// export function DialogTitle({ className = "", children }) {
//   return (
//     <h2 className={`text-lg font-semibold ${className}`}>
//       {children}
//     </h2>
//   );
// }